import { Skeleton } from "antd";

const LoadingImage = ({ isLoading, component, style }) => {
  return isLoading ? <Skeleton.Image active={true} style={style} /> : component;
};

export default LoadingImage;
